import { Skeleton } from '@/components/atoms/Skeleton';
import BeneficiosChippuMobileFallback from '@/components/organisms/BeneficiosChippu/Designs/Mobile/fallback';
import ListagemCreditosHomeFallbackMobile from '@/components/organisms/ListagemCreditosHome/fallback/Designs/Mobile';
import MinhaCarteiraDetalhamentoFallback from '@/components/organisms/MinhaCarteiraDetalhamento/fallback';
import {
  PrimeiraSecaoHomeMobile,
  SegundaSecaoHomeMobile,
  UltimaSecaoHomeMobile,
} from '../styles';

export default function HomePaginaMobileFallback() {
  return (
    <div>
      <Skeleton style={{ height: 478 }} />
      <PrimeiraSecaoHomeMobile>
        <BeneficiosChippuMobileFallback />
        <Skeleton style={{ height: 298 }} />
        <Skeleton style={{ height: 298 }} />
      </PrimeiraSecaoHomeMobile>
      <SegundaSecaoHomeMobile>
        <Skeleton style={{ height: 616 }} />
      </SegundaSecaoHomeMobile>
      <UltimaSecaoHomeMobile>
        <Skeleton style={{ height: 868 }} />
        <ListagemCreditosHomeFallbackMobile />
        <MinhaCarteiraDetalhamentoFallback />
      </UltimaSecaoHomeMobile>
    </div>
  );
}
